import "./i18n-config"
import {
  LANGUAGE_INTL_LOCALES,
  Language,
  Translator,
  isTranslationKey,
} from "@repo/common"
import { Locale as DateFnsLocale } from "date-fns"
import { enGB, sv } from "date-fns/locale"
import { useLocale, useMessages, useTranslations } from "use-intl"

const DATE_FNS_LOCALES: Record<Language, DateFnsLocale> = {
  sv,
  en: enGB,
}

export const getDateFnsLocale = (language: Language): DateFnsLocale =>
  DATE_FNS_LOCALES[language]

// Replaces `import { sv } from "date-fns/locale"` in components
export const useDateFnsLocale = (): DateFnsLocale =>
  getDateFnsLocale(useLocale())

// Replaces hardcoded "sv-SE" in toLocaleString/Intl calls
export const useIntlLocale = (): string => LANGUAGE_INTL_LOCALES[useLocale()]

// The root `t` typed as @repo/common's Translator, for apps that render
// @repo/ui but don't depend on use-intl themselves (the admin app).
export const useTranslator = (): Translator => useTranslations()

// Field errors come from zod schemas in @repo/common, whose messages are
// translation keys ("common.validation.required"). Translates a message that
// is a known key and returns anything else (a custom refine message, a server
// error) unchanged.
export const useTranslateFieldError = () => {
  const t = useTranslations()
  const messages = useMessages()

  return (message: string): string =>
    isTranslationKey(messages, message) ? t(message) : message
}
